//* Importing the necessary dependencies
import { API_URI } from "../../constants/consts";
import { api } from "../../services/apis/configs/axiosConfigs";

//? Import the necessary types from the types file
import {
  QuestionTest,
  GetQuestionTestsResponse,
  CreateQuestionTestInput,
} from "./types/types";

//? Import the Pagination type from the types file
import { Pagination } from "../../services/stores/types";

export const questionTestAPI = {
  /**
   * Fetches a paginated list of QuestionTest relations from the API.
   */
  getAll: async function (
    search: string = "",
    page: number = 1,
    token: string,
    perPage: number = 10
  ): Promise<GetQuestionTestsResponse> {
    const url = `${API_URI}/admin/private/question-tests`;

    return api
      .request({
        url,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const { data } = response.data;

        const pagination: Pagination = data.pagination
          ? {
              currentPage: data.pagination.currentPage,
              totalPages: data.pagination.totalPages,
              itemsPerPage: data.pagination.itemsPerPage,
              totalItems: data.pagination.totalItems,
            }
          : {
              currentPage: 0,
              totalPages: 0,
              itemsPerPage: 0,
              totalItems: 0,
            };

        return {
          questionTests: data.questionTests || [],
          pagination,
        };
      });
  },

  /**
   * Creates multiple QuestionTest relations.
   */
  create: async function (
    data: CreateQuestionTestInput,
    token: string
  ): Promise<QuestionTest[]> {
    return api
      .request({
        url: `${API_URI}/admin/private/question-tests`,
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        data,
      })
      .then((response) => response.data.data);
  },

  // Corrija a assinatura da função update para que o ID seja o primeiro parâmetro
  update: async function (
    id: string,
    data: CreateQuestionTestInput,
    token: string
  ): Promise<QuestionTest> {
    return api
      .request({
        url: `${API_URI}/admin/private/question-tests/${id}`,
        method: "PUT",
        headers: { Authorization: `Bearer ${token}` },
        data,
      })
      .then((response) => response.data.data);
  },
  /**
   * Deletes specific QuestionTest relations by their IDs.
   */
  delete: async function (ids: string[], token: string): Promise<void> {
    const requests = ids.map((id) =>
      api.request({
        url: `${API_URI}/admin/private/question-tests/${id}`,
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      })
    );

    // Use Promise.all to wait for all requests to finish
    return Promise.all(requests).then(() => {});
  },
};
